import { allChildEls, allChildNodes, childEls } from "func-xml";

const diffgrNs = "urn:schemas-microsoft-com:xml-diffgram-v1";


function findDiffgramNode(dom) {
    var response = allChildEls(dom)[0];
    var result = response && allChildEls(response)[0];

    if (!result) {
        throw new Error('Unable to find result node in web service response');
    }

    return childEls('diffgram', diffgrNs)(result)[0];
}

// Element -> void
// Removes all child nodes of the parent of <diffgram>, and appends the children of <diffgram> to that parent
function removeDiffgram(diffgram) {
    const parent = diffgram.parentNode;

    // Remove all current children
    for (const child of allChildNodes(parent)) {
        parent.removeChild(child);
    }

    // Append all of the diffgr element's children
    for (const child of allChildNodes(diffgram)) {
        parent.appendChild(child);
    }
}

// Case 48961
export const omitDiffgram = (dom) => {
    const diffgr = findDiffgramNode(dom);

    if (diffgr) {
        removeDiffgram(diffgr);
    }

    return dom;
}
